import React, { Component } from 'react';
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import AppStack from './AppStack'

class PortfolioItem extends Component {

	constructor(props){

       super(props);

			 // Get The Item
			 let item = props.portfolio.items.find((item)=> {return item.slug == props.match.params.item})

			 this.state = {
				 item: item
			 }

// 			 description
// :
// "A web platform that provides cost affordable, high quality, websites for churches and ministries."
// feature
// :
// "/assets/portfolio/thechurchco.png"
// image
// :
// "/assets/thechurchco.jpg"

    }

	render(){

		return (

			<AppStack className="basic">

				<section className="wysiwyg">

					<div className="container">

						<div className="page-title-container"><div className="page-title"><h1>{this.state.item.name}</h1></div></div>

						<div className="body">
							<p className="description" dangerouslySetInnerHTML={{__html:this.state.item.description}}></p>
							<p><a href={this.state.item.link} target="_blank">Visit Site</a></p>
							<div className="image">
								<img src={this.state.item.feature} />
							</div>
						</div>

					</div>

				</section>

			</AppStack>
		);

	}

}



const mapStateToProps = (state) => {
	return { portfolio: state.Portfolio };
}
const mapDispatchToProps = (dispatch) => {
	return {}
}

export default connect(mapStateToProps,mapDispatchToProps)(PortfolioItem)



// WEBPACK FOOTER //
// ./src/Components/PortfolioItem.js